<template>
    <div>
        <router-link :to="{name: 'image-create' }" class="button is-primary is-pulled-right">
            Upload image
        </router-link>

        <data-table :data-set="images" :page-length="50" :columns="[
            {name: 'Image', prop: 'normal_path', type: 'image', searchable: false, sortable: false},
            {name: 'Name', prop: ['name', 'extension'], type: 'text'},
            {name: 'Normal Size', prop: 'normal_size', type: 'number', filter: 'prettyBytes' },
            {name: 'Full Size', prop: 'full_size', type: 'number', filter: 'prettyBytes' },
            {name: 'Created', prop: 'created_at', type: 'date', searchable: false, sortable: true, filter: ['moment', ['from', 'now']]},
            {name: 'Updated', prop: 'created_at', type: 'date', searchable: false, sortable: true, filter: ['moment', ['from', 'now']]},
        ]">
            <template slot="column_Image" slot-scope="props">
                <img :src="props.row.thumbnail_path">
            </template>

            <template slot="column_Name" slot-scope="props">
                <router-link :to="{name:'image', params:{id: props.row.id}}">
                    {{ props.row.name }}.{{ props.row.extension }}
                </router-link>
                <div v-if="props.row.related.length > 0">
                    Linked to this image:
                    <br/>
                    <div v-for="(related) in props.row.related">
                        <div v-for="(item, type) in related">
                            <router-link v-if="type === 'product'"
                                         :to="{name: 'product', params:{id:item.id}}">{{item.short_name}} (product)
                            </router-link>
                            <router-link v-if="type === 'bundle'"
                                         :to="{name: 'bundle', params:{id:item.id}}">BU: {{item.name}} (bundle)
                            </router-link>
                            <router-link v-if="type === 'page'"
                                         :to="{name: 'page', params:{id:item.id}}">PA: {{item.name}} (page)
                            </router-link>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="controls" slot-scope="props">
                <td slot="controls" class="has-text-right">
                    <a class="delete" @click="deleteImage(props.row)"></a>
                </td>
            </template>
        </data-table>
    </div>
</template>

<style lang="scss" ref="stylesheet/scss">
    .image-size {
        display: inline-block;
        width: 75px;
    }
</style>

<script>
    import {mapGetters}   from "vuex"
    import {DELETE_IMAGE} from "../../store/mutation-types"

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['images'])
        },
        methods: {
            deleteImage(image) {
                let confirm = window.confirm('Are you sure? All links to this image will be deleted as well.')
                if (confirm) {
                    this.$store.dispatch(DELETE_IMAGE, image)
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ImageList.vue?1af7a89d